export const LINE = {
  MSG_USER_BY_LINE_ID_REQUEST: 'MSG_USER_BY_LINE_ID_REQUEST',
  MSG_USER_BY_LINE_ID_SUCCESS: 'MSG_USER_BY_LINE_ID_SUCCESS',
  MSG_USER_BY_LINE_ID_FAILURE: 'MSG_USER_BY_LINE_ID_FAILURE',
};
